import React, { useCallback, useState, useEffect, memo } from 'react';
import { Box } from '@material-ui/core';
import ReactResizeDetector from 'react-resize-detector';
import Swiper from 'react-id-swiper';

import { useSchedule } from '../context';
import ColumnDay from './ColumnDay';
import useStyles from './styles';
import Loading from './Loading';

const ColumnsAppointments = () => {
  const classes = useStyles();
  const {
    minColumnWidth,
    visibleColumns,
    setVisibleColumns,
    scheduleAppointments,
    setAppointmentsSwiper,
  } = useSchedule();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(!scheduleAppointments.length);
  }, [scheduleAppointments]);

  const calculateVisibleColumns = useCallback(
    width => {
      const calcVisibleColumns = Math.trunc(width / minColumnWidth);
      const maxVisibleColumns = calcVisibleColumns < 7 ? calcVisibleColumns : 7;
      setVisibleColumns(maxVisibleColumns);
    },
    [minColumnWidth, setVisibleColumns],
  );

  return (
    <Box className={classes.container}>
      <ReactResizeDetector handleWidth onResize={calculateVisibleColumns} />
      {loading && <Loading columns={visibleColumns} />}
      {!!visibleColumns && !loading && (
        <>
          <Swiper
            getSwiper={setAppointmentsSwiper}
            containerClass="slider-appointments"
            shouldSwiperUpdate
          >
            {scheduleAppointments.map(day => (
              <Box key={day.date} className="appointment-column-container">
                <ColumnDay
                  slots={day.slots}
                  date={day.date}
                  loaded={day.loaded}
                />
              </Box>
            ))}
          </Swiper>
        </>
      )}
    </Box>
  );
};

export default memo(ColumnsAppointments);
